import { Component, OnInit } from '@angular/core';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';


@Component({
  selector: 'app-list-empresa',
  templateUrl: './list-empresa.component.html',
  styleUrls: ['./list-empresa.component.scss']
})
export class ListEmpresaComponent implements OnInit {


  public arrayTriagem: [];
  query: string;

  constructor( 
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  AdicionarNovaEmpresa(){
    this.router.navigate(['/cadastro-empresa']);
  }

  VerProgarmas(){
    this.router.navigate(['/lista-programa-empresa']);
  }

  buscar(){
    this.util.showLoading();
    //let url = API + "Triagem/Triagem";  
    let url = "fake-data/empresa.json";  
    return this.ajax.get(url)
    .subscribe(response  => {
      this.arrayTriagem = response;

      this.util.closeLoading();      
    }, err => {
      
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Buscar Empresas");
    });
  }

  mostrarLink(item){
    console.log(item.iD_TRIAGEM);
    let message = ' ' +
    '<div class="modal-body"> ' +
    '		<h4 class="mb-2">URL</h4> ' +
    '		<div class="form-group mb-4"> ' +
    '			<input type="text" value="' + ""+ '" class="form-control pl-2" readonly=""> ' +
    '		</div>' +
    '<div>' ;

    Swal.fire({
      title: item.titulo,
      type: 'warning',
      html: message,
      //width: '95%'
    }).then((result) => {

    });

  } 

}
